export const firstSnapshot = {
  date: "2025-12-04",
  description: "Early Version",
  hash: "ec9c078",

  hero: {
    name: "Sebastian Wu",
    subtitle: "Grade 11 Student @ MHS",
    status: "Available for Opportunities"
  },

  aboutSections: [
    {
      title: "Who I Am",
      content: "Gr 11 student @ MHS"
    },
    {
      title: "Interests",
      content: "Math, coding, speedcubing"
    }
  ],

  skills: [
    {
      name: "Python",
      level: "Proficiebnt"
    },
    {
      name: "HTML",
      level: "Proficient"
    },
    {
      name: "CSS",
      level: "Intermediate"
    },
    {
      name: "Javascript",
      level: "Proficient"
    },
  ],

  features: {
    photography: false,
    cubing: false,
    guestbook: false,
    blog: false,
    navigation: false,
    konami: false,
    timeTravel: false,
    music: false,
    weather: true,
    clock: true,
    resume: false, 
  },

  styling: {
    hasBackgroundImage: false,
    cardOpacity: 0.95,
    borderRadius: "20px"
  }
};